import React, { useEffect, useState } from "react";
import { contactFrom } from "../lib/contact";
import { useLang } from "../context/LanguageContext";
import api from "../lib/api";
import { logger } from "../lib/logger";
import { NewsletterBand, LinkColumn, ConnectColumn } from "./footer/FooterParts";

export const Footer = () => {
  const { t, toggle, lang } = useLang();
  const [c, setC] = useState(contactFrom());

  useEffect(() => {
    api.get("/settings").then((r) => setC(contactFrom(r.data))).catch((e) => logger.error("settings load failed", e));
  }, []);

  const shopLinks = [["/shop", t("nav_shop")], ["/story", t("nav_story")], ["/perfumer", t("nav_perfumer")], ["/contact", t("nav_contact")]];
  const infoLinks = [["/shipping", t("shipping_delivery")], ["/privacy", t("privacy")], ["/terms", t("terms")]];

  return (
    <footer className="border-t border-[#262421] bg-[#0B0A08] mt-24">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 pt-16 md:pt-20 pb-4">
        <NewsletterBand t={t} lang={lang} />
      </div>
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 pb-16 md:pb-24 pt-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-8">
          <div className="col-span-2 md:col-span-1">
            <h3 className="serif text-2xl tracking-[0.2em] mb-4">OMR PERFUMER</h3>
            <p className="text-[#8A857D] text-sm leading-relaxed max-w-xs">{t("footer_tagline")}</p>
            <p className="text-[#6E685F] text-xs mt-4 uppercase tracking-widest">{t("location")}</p>
          </div>
          <LinkColumn title={t("nav_shop")} links={shopLinks} />
          <LinkColumn title="Information" links={infoLinks} />
          <ConnectColumn c={c} t={t} lang={lang} toggle={toggle} />
        </div>
        <div className="mt-16 pt-8 border-t border-[#262421] flex flex-col md:flex-row justify-between gap-3 text-xs text-[#6E685F] uppercase tracking-widest">
          <span>© {new Date().getFullYear()} OMR PERFUMER. {t("rights")}</span>
          <span>Abu Dhabi · UAE</span>
        </div>
      </div>
    </footer>
  );
};
